import React, { useEffect, useState } from 'react';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 100;
      setScrolled(isScrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (e, sectionId) => {
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      const offsetTop = element.offsetTop - 80;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="nav-brand">
          <span className="brand-icon">📱</span>
          <span className="brand-text">Global SMS</span>
        </div>
        <div className="nav-links">
          <a href="#features" onClick={(e) => scrollToSection(e, 'features')}>기능</a>
          <a href="#contact" className="btn-telegram" onClick={(e) => scrollToSection(e, 'contact')}>문의하기</a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
